import { expenseCategoryUpdateApi } from "../../api/expenseCategory/expenseCategoryUpdateApi"

type PayloadShape = Parameters<typeof expenseCategoryUpdateApi>[0]

export async function expenseCategoryUpdateService(payload: PayloadShape, token: string) {
	return await expenseCategoryUpdateApi(payload, token)
}
